/** Dominio usado para armar el correo de vendedoras nuevas (ver config/initializers/email_domain.rb). */
export const SELLER_EMAIL_DOMAIN = import.meta.env.VITE_EMAIL_DOMAIN ?? 'magicomundo.com'

/** Número de WhatsApp del negocio para consultas desde la tienda pública. */
export const STORE_WHATSAPP_NUMBER = import.meta.env.VITE_WHATSAPP_NUMBER ?? '3024526814'
